import React from 'react';
import { MultiFileUploadWizard } from '@UI-Elements/FileUpload/AttachFileScreen/components/MultiFileUploadWizard';
import { fetchDocumentsFromStorage, handleRemoveFile } from '@UI-Elements/FileUpload/fileUploadUtils';
import { getMultiFilesProps } from '../dropzone-files-utils';
import { IFileBatch } from '../../../sp-types';
import { comment } from '../../../sp-types/FutureOrderType';
import { sendEmail, sendWa } from '../../../utils/email-utils';

interface Props {
  batch: Partial<IFileBatch>;
  docType: string;
  setLoading: (_loading: boolean) => void;
  onFilesChange: (_filePaths: string[], _fileUrls: string[], _dType: string) => void;
  onFileDelete: (_fileIndex: number, _docType: string) => void;
  userId: string;
  accountId: string;
}
export const FilesPanel: React.FC<Props> = ({
  batch,
  docType,
  setLoading,
  onFilesChange,
  onFileDelete,
  accountId,
  userId,
}) => {
  const { files } = batch;
  const [filePaths, setFilePaths] = React.useState<string[]>(files?.[docType]?.map((a) => a.path) || []);
  const [fileUrls, setFileUrls] = React.useState<string[]>(files?.[docType]?.map((a) => a.url) || []);

  const [uploaded, setUploaded] = React.useState<string[] | undefined>();

  React.useEffect(() => {
    if (uploaded && uploaded.length > 0) {
      sendEmail(
        `Files uploaded in account: ${accountId}`,
        `In account: <b>${accountId}</b> files uploaded to batch: ${batch.id}<br/><hr/>${uploaded.join('<br/>')}
        <hr/>
        <br/>
        UserId: ${userId}`,
        'moshe,matanel,roy',
      );

      sendWa(`files were uploaded to account: ${accountId} \n Batch: ${batch.id} \n ${uploaded.join('\n')}`);
      setUploaded(undefined);
    }
  }, [uploaded]);

  React.useEffect(() => {
    if (files) {
      setFilePaths(files[docType]?.map((a) => a.path) || []);
      setFileUrls(files[docType]?.map((a) => a.url) || []);
    }
  }, [files, batch.id, docType]);

  const [fileError, setFileError] = React.useState<any>();

  const onFilesUploaded = async (uploadedPaths: string[]) => {
    const uploadedUrls = await fetchDocumentsFromStorage(uploadedPaths, () => null);
    setFilePaths((prevPaths) => [...prevPaths, ...uploadedPaths]);
    setFileUrls((prevUrls) => [...prevUrls, ...uploadedUrls]);

    setUploaded(uploadedPaths);
    onFilesChange(uploadedPaths, uploadedUrls, docType);
  };

  const getPath = ({ id, createdAt, accountId }: IFileBatch, docType: string) =>
    `${accountId}/${createdAt?.toDate().toLocaleDateString('en-CA')}-${id}/${docType}/`;

  const dropzoneConfig = React.useCallback(() => {
    const fileExactPath = getPath(batch as IFileBatch, docType);

    return getMultiFilesProps(onFilesUploaded, setFileError, setLoading, fileExactPath);
  }, [batch.id, batch.accountId, docType]);

  const onDeleteFile = async (path: string) => {
    const index = filePaths.indexOf(path);
    try {
      await handleRemoveFile(path, filePaths, (_v) => 0, setFilePaths);
    } catch (e) {
      console.error('error delete', e);
    }

    onFileDelete(index, docType);
  };

  const onCommentsChange = (comments: comment[]) => {
    batch.comments = [
      ...(batch.comments?.filter((c) => c.docType !== docType) || []),
      ...comments.map((c) => ({ ...c, docType: c.docType || docType })),
    ];
    console.log('comm', batch.comments);
    onFilesChange([], [], docType);
  };

  return (
    <div>
      <MultiFileUploadWizard
        fileUrls={fileUrls}
        comments={batch.comments?.filter((c) => c.docType === docType) || []}
        onCommentsChanged={onCommentsChange}
        filePaths={filePaths}
        dropzoneConfig={dropzoneConfig()}
        onDeleteFile={onDeleteFile}
        gotoManualInput={console.log}
        options={{ isHideManual: true, isShowEmpty: true, disabled: batch.status !== 'draft' }}
      />
    </div>
  );
};
